import { useController } from 'react-hook-form'
import { DatePicker } from '@mui/x-date-pickers'

import dayjs from 'dayjs'
import PropTypes from 'prop-types'

import s from './styles.module.scss'

export const DateField = ({
  className = '',
  fullWidth = false,
  label,
  name,
  initValue = null,
  margin = true,
  variant = 'outlined',
}) => {
  const {
    field: { onChange, onBlur, value = initValue, ref },
    fieldState: { error },
  } = useController({ name })

  return (
    <div className={margin ? s.inputContainer : s.withoutMargin}>
      {label && <div className={s.titleInput}>{label}</div>}
      <DatePicker
        className={className}
        inputRef={ref}
        format="DD/MM/YYYY"
        timezone="UTC"
        value={value ? dayjs(value) : null}
        onChange={(newDate) => {
          if (newDate && dayjs(newDate).isValid()) {
            onChange(dayjs(newDate).toISOString())
          }
        }}
        slotProps={{
          textField: {
            variant,
            fullWidth,
            className,
            error: Boolean(error),
            helperText: error ? error.message : 'Ingresar la fecha en formato DD/MM/YYYY',
            name,
            onBlur,
            sx: {
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  border: '2px solid #0f1333',
                },
                '&:hover fieldset': {
                  borderColor: '#0f1333',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#0f1333',
                },
              },
            },
          },
        }}
      />
    </div>
  )
}

DateField.propTypes = {
  className: PropTypes.string,
  initValue: PropTypes.string,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  margin: PropTypes.bool,
  variant: PropTypes.string,
}

export default DateField
